import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import { Wrapper, Table, Header, LeaderboardWrapper } from './elements';
import LeaderboardEntry from './LeaderboardEntry';

import { useText } from 'common/hooks';
import { Leaderboard as LeaderboardType } from 'challenge/module/modules/visualisations/types';
import { LeaderboardTitle } from './LeaderboardTitle';
import { InfoIconTooltip } from './InfoIconTooltip';

type Props = {
  readonly leaderboard: LeaderboardType[];
  readonly title: string;
  readonly info?: string;
};

const deps = {
  indicator: state.challenge.campaign.indicator,
};

function Leaderboard({
  leaderboard,
  title,
  indicator,
  info,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Wrapper>
      <LeaderboardTitle title={title}>
        {info ? <InfoIconTooltip text={info} /> : null}
      </LeaderboardTitle>
      <Table>
        <Header
          nameText={t('challenge.ChaPaD22B.LB01.name')}
          activitiesText={t('challenge.ChaPaD22B.LB01.activities')}
          labelText={
            indicator ? t(`challenge.LBHead8.saving_${indicator}`) : ''
          }
        />
        <LeaderboardWrapper>
          {leaderboard.map(entry => (
            <LeaderboardEntry key={entry.key} entry={entry} />
          ))}
        </LeaderboardWrapper>
      </Table>
    </Wrapper>
  );
}

export default connect<Props, typeof deps>(deps, Leaderboard);
